// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cancel-indicator.c-indicator ul:before{margin:0 40px 0 52px}", ""]);
// Exports
module.exports = exports;
